import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41ea1a80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-container tw-flex tw-flex-col tw-p-[22px] tw-gap-[16px] tw-bg-[#FCFCFD] tw-rounded-[6px]" }
const _hoisted_2 = { class: "tw-text-[#211F58] tw-text-[15px] tw-leading-[normal] tw-font-[600]" }
const _hoisted_3 = {
  key: 0,
  class: "tw-gap-[10px] tw-flex tw-justify-between"
}
const _hoisted_4 = { class: "tw-gap-[10px] tw-flex selected-box tw-flex-1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "selected-text tw-leading-[130%] tw-font-[500] tw-text-[11px] tw-text-[#387DFF]"
}
const _hoisted_11 = { class: "tw-w-[14px] tw-h-[14px] tw-bg-[white] tw-rounded-[13.455px] tw-items-center tw-justify-center tw-flex" }
const _hoisted_12 = {
  key: 1,
  class: "tw-bg-[#fff] tw-items-center tw-pl-[15px] tw-py-[6px] tw-pr-[6px] tw-flex tw-justify-center tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-[#EFF0F1] tw-h-[46px]"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/search_black_icon.svg",
  alt: "search_icon"
}, null, -1))
const _hoisted_14 = ["placeholder"]
const _hoisted_15 = { class: "tw-bg-[#fff] tw-border-[#EFF0F1] tw-border-[1px] tw-border-solid tw-flex tw-rounded-[6px] tw-flex-col tw-max-h-[315px] tw-overflow-auto" }
const _hoisted_16 = {
  class: /*#__PURE__*/_normalizeClass(`tw-flex tw-justify-between tw-items-center`)
}
const _hoisted_17 = { class: "tw-flex tw-gap-[5px] tw-items-center tw-justify-center" }
const _hoisted_18 = {
  key: 0,
  class: "tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
}
const _hoisted_19 = {
  key: 1,
  class: "tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
}
const _hoisted_20 = {
  key: 2,
  class: "tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
}
const _hoisted_21 = {
  key: 3,
  class: "tw-flex tw-items-center tw-w-[14px] tw-h-[14px]"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "7",
  viewBox: "0 0 10 7",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 0,
  class: "tw-gap-[15px]"
}
const _hoisted_26 = {
  key: 0,
  class: "create-new-ass-modal-note"
}
const _hoisted_27 = {
  key: 0,
  class: /*#__PURE__*/_normalizeClass('tw-flex tw-gap-[15px] tw-mr-[15px]')
}
const _hoisted_28 = ["onClick"]
const _hoisted_29 = {
  key: 0,
  class: "tw-text-[#b7b7b7] tw-text-[12px] tw-font-[400] tw-ml-[5px]"
}
const _hoisted_30 = {
  key: 1,
  class: /*#__PURE__*/_normalizeClass('tw-flex tw-gap-5')
}
const _hoisted_31 = ["onClick"]
const _hoisted_32 = {
  key: 0,
  class: "tw-text-[#b7b7b7] tw-text-[12px] tw-font-[400] tw-ml-[5px]"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = {
  key: 0,
  class: "tw-flex tw-p-[15px] tw-pt-[12px] tw-flex-col"
}
const _hoisted_35 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "7",
  viewBox: "0 0 10 7",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = {
  key: 0,
  class: "tw-flex tw-gap-[15px] tw-mt-[15px] tw-mb-[10px]"
}
const _hoisted_39 = { class: "tw-flex-1 tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_40 = { class: "tw-flex-1 tw-text-[#B7B7B7] tw-text-[13px] tw-font-[400]" }
const _hoisted_41 = {
  key: 1,
  class: "tw-flex tw-gap-[15px]"
}
const _hoisted_42 = { class: "tw-flex-1" }
const _hoisted_43 = { class: "tw-flex-1 to-class" }
const _hoisted_44 = { class: "tw-flex tw-justify-end" }

import closeIcon from "@/components/svgs/closeIcon.vue";
import Importance from "@/components/svgs/importance.vue";
import Impact from "@/components/svgs/impact.vue";
import Effort from "@/components/svgs/effort.vue";
import Cost from "@/components/svgs/cost.vue";
import { computed, onMounted, PropType, Ref, ref, watch } from "vue";
import {
  IFilterSelect,
  IFilterTarget,
  IFilterTargetValue,
  IOriginData,
} from "@/interfaces/common/common";
import { getComponentUiText } from "@/utils/utilities";
import CustomCheckBox from "@/components/common/customCheckBox.vue";
import DatePickInput from "@/components/common/datePickInput.vue";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import {
  FILTER_MODAL_TYPE,
  mainAssessmentFilterDefaul,
} from "@/utils/constants";
import cloneDeep from "lodash/cloneDeep";
import InputFilterModal from "../inputFilterModal.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'filterModal',
  props: {
  isSearch: {
    type: Boolean,
    required: true,
  },
  targets: {
    type: Array as PropType<Array<IFilterTarget>>,
    required: true,
    default: () => [],
  },
  isDate: {
    type: Boolean,
    required: true,
  },
  originalData: {
    type: Object as PropType<IOriginData>,
    required: true,
  },
  showMoreActions: {
    type: Boolean,
    required: false,
    default: false,
  },
  type: {
    type: String,
    required: false,
    default: "",
  },
  outsideFilterModal: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["update:apply-filter"],
  setup(__props, { emit: emits }) {

const props = __props;



const targetsFilter: Ref<Array<IFilterTarget>> = ref(props.targets);

watch(
  () => props.targets,
  (newValue) => {
    targetsFilter.value = newValue;
  },
  { immediate: true },
);

watch(
  () => props.outsideFilterModal,
  (newValue) => {
    if (newValue) {
      applyFilter();
    }
  },
  { immediate: true },
);

const filterSelecteds: Ref<IFilterSelect[]> = ref(
  props.originalData?.filterSelected || [],
);
const inputValue = ref(props.originalData?.searchValue);
const searchValue = ref(props.originalData?.searchValue);
const from = ref(props.originalData?.from);
const to = ref(props.originalData?.to);
const selectedDateOpen = ref(false);
const listFilterShow = computed(() => {
  let list = filterSelecteds.value.filter((item) => !item.value.isDefault);
  const listCompliance = list.filter((item) => {
    return item.targetId === "itemCompleteValue-percentage";
  });
  const listScoreIncrease = list.filter((item) => {
    return item.targetId === "score-increase";
  });
  list = list.filter(
    (item) =>
      item.targetId !== "itemCompleteValue-percentage" &&
      item.targetId !== "score-increase",
  );

  if (listCompliance.length > 0) {
    let text = "";

    if (listCompliance.length > 1) {
      text = getComponentUiText(
        "app-component-assessment-display-options-filter-tag-between-1",
        false,
        {
          below:
            listCompliance.find((item) => item.value.id === 0)?.value.percent ??
            "",
          above:
            listCompliance.find((item) => item.value.id === 1)?.value.percent ??
            "",
        },
      );

      list.push({
        targetId: "itemCompleteValue-percentage",
        value: {
          id: [0, 1],
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    } else {
      if (listCompliance[0].value.id === 0) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-below-1",
          false,
          {
            below: listCompliance[0].value.percent ?? "",
          },
        );
      } else if (listCompliance[0].value.id === 1) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-above-1",
          false,
          {
            above: listCompliance[0].value.percent ?? "",
          },
        );
      }

      list.push({
        targetId: "itemCompleteValue-percentage",
        value: {
          id: listCompliance[0].value.id,
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    }
  }

  if (listScoreIncrease.length > 0) {
    let text = "";

    if (listScoreIncrease.length > 1) {
      text = getComponentUiText(
        "app-component-assessment-display-options-filter-tag-score-between-1",
        false,
        {
          below:
            listScoreIncrease.find((item) => item.value.id === 0)?.value
              .percent ?? "",
          above:
            listScoreIncrease.find((item) => item.value.id === 1)?.value
              .percent ?? "",
        },
      );

      list.push({
        targetId: "score-increase",
        value: {
          id: [0, 1],
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    } else {
      if (listScoreIncrease[0].value.id === 0) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-score-below-1",
          false,
          {
            below: listScoreIncrease[0].value.percent ?? "",
          },
        );
      } else if (listScoreIncrease[0].value.id === 1) {
        text = getComponentUiText(
          "app-component-assessment-display-options-filter-tag-score-above-1",
          false,
          {
            above: listScoreIncrease[0].value.percent ?? "",
          },
        );
      }
      list.push({
        targetId: "score-increase",
        value: {
          id: listScoreIncrease[0].value.id,
          text,
          isDefault: false,
          isHardText: true,
        },
      });
    }
  }
  return list;
});

const calNumberTarget = (targetId) => {
  if (filterSelecteds.value.length === 0) return 0;
  return filterSelecteds.value?.filter(
    (item) => item.targetId === targetId && !item.value.isDefault,
  ).length;
};

onMounted(() => {
  if (
    filterSelecteds.value.length === 0 &&
    props.type === FILTER_MODAL_TYPE.mainChecklist
  ) {
    filterSelecteds.value = mainAssessmentFilterDefaul;
  }
});

watch(
  () => filterSelecteds.value,
  (newValue) => {
    if (
      filterSelecteds.value.length === 0 &&
      props.type === FILTER_MODAL_TYPE.mainChecklist
    ) {
      filterSelecteds.value = cloneDeep(mainAssessmentFilterDefaul);
      ``;
    }
  },
);

const onFocusValue = (_, target, val: IFilterTargetValue) => {
  if (
    !filterSelecteds.value.filter(
      (item) => item.targetId === target.targetId && item.value.id === val.id,
    ).length
  ) {
    updateItemFilter(val, target.targetId);
  }
};

const onUpdateInput = (percent, target, val: IFilterTargetValue) => {
  filterSelecteds.value = filterSelecteds.value.map((item) => {
    if (item.targetId === target.targetId && item.value.id === val.id) {
      return {
        ...item,
        value: {
          ...item.value,
          percent,
        },
      };
    }
    return item;
  });
};

const clearAll = () => {
  filterSelecteds.value = [];
  searchValue.value = "";
};

const updateItemFilter = (item, targetId?) => {
  let idx;
  if (!targetId) {
    if (Array.isArray(item.value.id)) {
      idx = item.value.id.map((id) =>
        filterSelecteds.value.findIndex(
          (filter) =>
            filter.targetId === item.targetId && filter.value.id === id,
        ),
      );
    } else {
      idx = filterSelecteds.value.findIndex(
        (filter) =>
          filter.targetId === item.targetId &&
          filter.value.id === item.value.id,
      );
    }
  } else {
    const isRadio =
      props.targets.find((target) => target.targetId === targetId)?.isRadio ||
      false;
    if (isRadio) {
      filterSelecteds.value = filterSelecteds.value.filter(
        (filter) => filter.targetId !== targetId,
      );
      filterSelecteds.value.push({
        targetId: targetId,
        value: item,
      });
      return;
    }
    idx = filterSelecteds.value.findIndex(
      (filter) => filter.targetId === targetId && filter.value.id === item.id,
    );
  }
  if (Array.isArray(idx)) {
    idx
      .sort((a, b) => (a > b ? -1 : 1))
      .forEach((i) => {
        if (i !== -1) {
          filterSelecteds.value.splice(i, 1);
        } else {
          filterSelecteds.value.push({
            targetId: targetId || item.targetId,
            value: item,
          });
        }
      });
    return;
  }
  idx === -1
    ? filterSelecteds.value.push({
        targetId: targetId || item.targetId,
        value: item,
      })
    : filterSelecteds.value.splice(idx, 1);
};

const applyFilter = () => {
  const filterSelectedsFiltered = filterSelecteds.value.filter(
    (item) => item.value.type !== "input" || item.value.percent,
  );
  emits("update:apply-filter", {
    search: searchValue.value,
    filterSelecteds: filterSelectedsFiltered,
    from: from.value,
    to: to.value,
  });
};

watch(
  () => props.showMoreActions,
  (newValue) => {
    if (newValue) {
      filterSelecteds.value = props.originalData?.filterSelected || [];
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getComponentUiText)("app-common-filter-modal-title-1")), 1),
    (listFilterShow.value?.length || (searchValue.value && __props.isSearch))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listFilterShow.value, (item) => {
              return (_openBlock(), _createElementBlock("p", {
                key: item.targetId,
                class: "selected-text tw-leading-[130%] tw-font-[500] tw-text-[11px] tw-text-[#387DFF]"
              }, [
                (item.targetId === 'checklistItemCostId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-display-options-filter-importance-option-cost-1",
              )) + ": ", 1))
                  : _createCommentVNode("", true),
                (item.targetId === 'checklistItemEffortId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-display-options-filter-importance-option-effort-1",
              )) + ": ", 1))
                  : _createCommentVNode("", true),
                (item.targetId === 'checklistItemImpactId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-display-options-filter-importance-option-impact-1",
              )) + ": ", 1))
                  : _createCommentVNode("", true),
                (item.targetId === 'checklistItemImportanceId')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-display-options-filter-importance-1",
              )) + ": ", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(!item.value.isHardText
              ? _unref(getComponentUiText)(item.value.text)
              : item.value.text) + " ", 1),
                _createElementVNode("span", {
                  class: "tw-cursor-pointer tw-w-[14px] tw-h-[14px] tw-bg-[white] tw-rounded-[13.455px] tw-items-center tw-justify-center tw-flex",
                  onClick: () => updateItemFilter(item)
                }, [
                  _createVNode(closeIcon, {
                    h: 6,
                    x1: 5.33398,
                    y1: 0,
                    w1: 0.942758,
                    h1: 7.54206,
                    x2: 0.00195312,
                    y2: 0.666992,
                    w2: 0.942758,
                    h2: 7.54206,
                    size: 6,
                    color: '#DBDBDB'
                  })
                ], 8, _hoisted_9)
              ]))
            }), 128)),
            (searchValue.value && __props.isSearch)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, [
                  _createTextVNode(_toDisplayString(`"${searchValue.value}"`) + " ", 1),
                  _createElementVNode("span", _hoisted_11, [
                    _createVNode(closeIcon, {
                      h: 6,
                      x1: 5.33398,
                      y1: 0,
                      w1: 0.942758,
                      h1: 7.54206,
                      x2: 0.00195312,
                      y2: 0.666992,
                      w2: 0.942758,
                      h2: 7.54206,
                      size: 6,
                      color: '#DBDBDB',
                      onClick: _cache[0] || (_cache[0] = 
                () => {
                  searchValue.value = '';
                }
              )
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("p", {
            class: "tw-text-[#387DFF] tw-cursor-pointer tw-text-[11px] tw-font-[500] tw-leading-[14.3px] tw-mt-[3px]",
            onClick: _cache[1] || (_cache[1] = () => clearAll())
          }, _toDisplayString(`${_unref(getComponentUiText)("app-common-filter-modal-clear-all-link-1")} (${
            listFilterShow.value.length + (searchValue.value && __props.isSearch ? 1 : 0)
          })`), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.isSearch)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _hoisted_13,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue).value = $event)),
            type: "text",
            placeholder: _unref(getComponentUiText)('app-table-search-prompt-text-1'),
            class: "tw-placeholder-[#B7B7B7] tw-border-none tw-ml-[11px] tw-w-full tw-text-[#211F58] tw-text-[13px] tw-font-[500]",
            onInput: _cache[3] || (_cache[3] = (val) => (inputValue.value = val.target?.value))
          }, null, 40, _hoisted_14), [
            [_vModelText, inputValue.value]
          ]),
          (inputValue.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "tw-bg-transparent tw-border-none tw-outline-none",
                onClick: _cache[4] || (_cache[4] = 
          () => {
            inputValue.value = '';
          }
        )
              }, [
                _createVNode(CloseBoxIcon, {
                  size: 14,
                  color: "#DBDBDB"
                })
              ]))
            : _createCommentVNode("", true),
          (inputValue.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                class: "tw-cursor-pointer tw-ml-[17px] tw-tracking-[1px] tw-text-[#387DFF] tw-text-[10px] tw-leading-[100%] tw-font-[700] tw-p-[11px] tw-flex tw-items-center tw-border-[1px] tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]",
                onClick: _cache[5] || (_cache[5] = 
          () => {
            searchValue.value = inputValue.value;
            applyFilter();
          }
        )
              }, _toDisplayString(_unref(getComponentUiText)("app-common-filter-modal-search-button-1")), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_15, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(targetsFilter.value, (target, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: target.targetId,
          class: _normalizeClass(` tw-flex tw-flex-col tw-px-[15px] ${
          index !== targetsFilter.value.length - 1 || __props.isDate
            ? 'border-bottom-box'
            : ''
        } ${
          target.targetId === 'isMaster' ? 'tw-gap-[10px]' : 'tw-gap-[15px]'
        }`)
        }, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("p", {
              class: _normalizeClass(`${
              target.values[0].type === 'input' && target.isOpen
                ? 'tw-pt-[12px]'
                : 'tw-py-[12px]'
            } tw-text-[13px] tw-font-[500] ${
              calNumberTarget(target.targetId)
                ? 'tw-text-[#211F58]'
                : 'tw-text-[#878787]'
            }`)
            }, _toDisplayString(`${_unref(getComponentUiText)(target.targetText)}${
                calNumberTarget(target.targetId)
                  ? " (" + calNumberTarget(target.targetId) + ")"
                  : ""
              }`), 3),
            _createElementVNode("div", _hoisted_17, [
              (target.targetId === 'checklistItemImportanceId')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createVNode(Importance, {
                      class: _normalizeClass(['info-icon', 'tw-text-[#904BD6]'])
                    })
                  ]))
                : _createCommentVNode("", true),
              (target.targetId === 'checklistItemImpactId')
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(Impact, {
                      class: _normalizeClass(['info-icon', 'tw-text-[#904BD6]'])
                    })
                  ]))
                : _createCommentVNode("", true),
              (target.targetId === 'checklistItemEffortId')
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createVNode(Effort, {
                      class: _normalizeClass(['info-icon', 'tw-text-[#904BD6]'])
                    })
                  ]))
                : _createCommentVNode("", true),
              (target.targetId === 'checklistItemCostId')
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _createVNode(Cost, {
                      class: _normalizeClass(['info-icon', 'tw-text-[#904BD6]'])
                    })
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("span", {
                class: _normalizeClass(`tw-items-center tw-flex tw-cursor-pointer tw-z-[1] tw-p-[12px] arrowIcon ${
                target.isOpen ? 'rotated tw-pl-0 ' : 'tw-pr-0 '
              }`),
                onClick: 
                () => {
                  target.isOpen = !target.isOpen;
                  targetsFilter.value[index] = target;
                }
              
              }, _hoisted_24, 10, _hoisted_22)
            ])
          ]),
          (target.isOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (target.targetId === 'isMaster' && target.isOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                      _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-display-options-filter-show-master-items-note-1",
              )), 1)
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(target.values, (val, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: val.id,
                    class: _normalizeClass(`tw-flex tw-items-center ${
              idx === target.values.length - 1
                ? target.isRadio
                  ? 'tw-mb-[26px]'
                  : 'tw-mb-[15px]'
                : val.type === 'input'
                  ? 'tw-mb-[15px]'
                  : 'tw-mb-[10px]'
            } tw-justify-between`)
                  }, [
                    (val.type === 'input')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(CustomCheckBox, {
                            class: _normalizeClass(`!tw-mb-0 !tw-h-[20px] !tw-pl-0 tw-ml-[0px] tw-mr-[20px]`),
                            size: "20px",
                            "is-checked": 
                  filterSelecteds.value.filter(
                    (item) =>
                      item.targetId === target.targetId &&
                      item.value.id === val.id,
                  ).length > 0
                ,
                            "is-force-select": target.isRadio,
                            "onUpdate:isChecked": ($event: any) => (updateItemFilter(val, target.targetId))
                          }, null, 8, ["is-checked", "is-force-select", "onUpdate:isChecked"]),
                          _createElementVNode("p", {
                            class: "tw-cursor-pointer tw-text-[13px] tw-font-[500] tw-leading-normal tw-text-[#231F20]",
                            onClick: ($event: any) => (updateItemFilter(val, target.targetId))
                          }, [
                            _createTextVNode(_toDisplayString(!val.isHardText ? _unref(getComponentUiText)(val.text) : val.text) + " ", 1),
                            (val.isDefault)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_29, "(" + _toDisplayString(_unref(getComponentUiText)(
                      "app-component-filter-modal-default-tag-1",
                    )) + ")", 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_28)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_30, [
                          _createVNode(CustomCheckBox, {
                            class: _normalizeClass(`!tw-mb-0 !tw-h-[20px] !tw-pl-0 tw-ml-[0px] tw-mr-[20px]`),
                            size: "20px",
                            "is-checked": 
                  filterSelecteds.value.filter(
                    (item) =>
                      item.targetId === target.targetId &&
                      item.value.id === val.id,
                  ).length > 0
                ,
                            "is-force-select": target.isRadio,
                            "onUpdate:isChecked": ($event: any) => (updateItemFilter(val, target.targetId))
                          }, null, 8, ["is-checked", "is-force-select", "onUpdate:isChecked"]),
                          _createElementVNode("p", {
                            class: "tw-cursor-pointer tw-text-[13px] tw-font-[500] tw-leading-normal tw-text-[#231F20]",
                            onClick: ($event: any) => (updateItemFilter(val, target.targetId))
                          }, [
                            _createTextVNode(_toDisplayString(!val.isHardText ? _unref(getComponentUiText)(val.text) : val.text) + " ", 1),
                            (val.isDefault)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_32, "(" + _toDisplayString(_unref(getComponentUiText)(
                      "app-component-filter-modal-default-tag-1",
                    )) + ")", 1))
                              : _createCommentVNode("", true)
                          ], 8, _hoisted_31)
                        ])),
                    (val.type === 'input')
                      ? (_openBlock(), _createBlock(InputFilterModal, {
                          key: 2,
                          "id-percent-input": `PercentInput-${target.targetId}-${val.id}`,
                          value: 
                filterSelecteds.value.find(
                  (item) =>
                    item.targetId === target.targetId &&
                    item.value.id === val.id,
                )?.value?.percent ?? ''
              ,
                          "is-show-button-clear": true,
                          "is-in-range100": !!val.hindText,
                          "hint-text": val.hindText ?? '',
                          "class-text": `!tw-font-[400] !tw-text-left placeholder:!tw-text-left`,
                          fixed: val.hindText ? 0 : 1,
                          disabled: false,
                          "onUpdate:modelValue": 
                (percent) => onUpdateInput(percent, target, val)
              ,
                          onFocus: (percent) => onFocusValue(percent, target, val)
                        }, null, 8, ["id-percent-input", "value", "is-in-range100", "hint-text", "fixed", "onUpdate:modelValue", "onFocus"]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128)),
                (
              (!target.isRadio ||
                (target.isRadio &&
                  target.targetId === 'checklistItemCategoryId')) &&
              filterSelecteds.value.filter(
                (item) => item.targetId === target.targetId,
              ).length > 0
            )
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 1,
                      class: "tw-text-[#387DFF] !tw-mb-[26px] tw-text-[13px] tw-font-[400] tw-leading-[145%] tw-underline tw-decoration-solid clear-text-link tw-cursor-pointer",
                      onClick: 
              () => {
                filterSelecteds.value = filterSelecteds.value.filter(
                  (item) => item.targetId !== target.targetId,
                );
              }
            
                    }, _toDisplayString(_unref(getComponentUiText)("app-common-filter-modal-clear-link-1")), 9, _hoisted_33))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ], 2))
      }), 128)),
      (__props.isDate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("p", {
                class: _normalizeClass(` tw-text-[13px] tw-font-[500] ${
              from.value || to.value ? 'tw-text-[#211F58]' : 'tw-text-[#878787]'
            }`)
              }, _toDisplayString(_unref(getComponentUiText)("app-common-filter-modal-select-date-target-1")), 3),
              _createElementVNode("span", {
                class: _normalizeClass(`tw-items-center tw-flex tw-cursor-pointer tw-z-[1] arrowIcon ${
              selectedDateOpen.value ? 'rotated tw-pr-[10px]' : ''
            }`),
                onClick: _cache[6] || (_cache[6] = () => (selectedDateOpen.value = !selectedDateOpen.value))
              }, _hoisted_37, 2)
            ]),
            (selectedDateOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("p", _hoisted_39, _toDisplayString(_unref(getComponentUiText)(
                "app-common-filter-modal-select-date-target-from-1",
              )), 1),
                  _createElementVNode("p", _hoisted_40, _toDisplayString(_unref(getComponentUiText)(
                "app-common-filter-modal-select-date-target-to-1",
              )), 1)
                ]))
              : _createCommentVNode("", true),
            (selectedDateOpen.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                  _createElementVNode("div", _hoisted_42, [
                    _createVNode(DatePickInput, {
                      modelValue: from.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((from).value = $event)),
                      "class-name": "!tw-h-[44px] !tw-px-[12px]",
                      "class-name-icon": "icon-class",
                      "ref-picker": "refPickers",
                      "is-auto-focus": false
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_43, [
                    _createVNode(DatePickInput, {
                      modelValue: to.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((to).value = $event)),
                      "is-auto-focus": false,
                      "class-name": "!tw-h-[44px] !tw-px-[12px]",
                      "class-name-icon": "icon-class"
                    }, null, 8, ["modelValue"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_44, [
      _createVNode(_component_b_button, {
        pill: "",
        variant: "primary",
        "data-cy": "add-domain-modal-button",
        class: "button-add-domain tw-bg-[#387DFF] tw-h-[37px] !tw-text-[13px] !tw-font-[500] !tw-leading-[100%] tw-font-Poppins",
        type: "submit",
        onClick: _cache[9] || (_cache[9] = 
          () => {
            applyFilter();
          }
        )
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-common-filter-modal-apply-filter-button-1")), 1)
        ]),
        _: 1
      })
    ])
  ]))
}
}

})